import { useCallback } from 'react';

import { useObjectSidebarActions, useIsObjectSidebarShown } from '@confluence/object-sidebar-api';
import {
	useMoreActionsObjectSidebarTourActions,
	MoreActionsObjectSidebarTourSteps,
} from '@confluence/object-sidebar-components';

export const useLabelsShowMeHandler = () => {
	const { goToStep } = useMoreActionsObjectSidebarTourActions();
	const { setSidebarControlExpandCollapsedState, hideObjectSidebar } = useObjectSidebarActions();
	const objectSidebarShown = useIsObjectSidebarShown();

	const openObjectSidebarSpotlight = useCallback(() => {
		setSidebarControlExpandCollapsedState('expanded');
		goToStep(MoreActionsObjectSidebarTourSteps.SECOND);
	}, [setSidebarControlExpandCollapsedState, goToStep]);

	return () => {
		if (objectSidebarShown) {
			// close side panel await warning dialog if comments are still in draft
			hideObjectSidebar(() => {
				openObjectSidebarSpotlight();
			});
		} else {
			openObjectSidebarSpotlight();
		}
	};
};
